import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light-border.css';

class CardsLabels {
    init() {
        this.cards = [...document.querySelector('.cards-grid').querySelectorAll('.news-card')];
        this.cards.forEach((item) => {
            const topic = item.querySelector('[data-dc-news-card-topic]');
            if (topic !== null) {
                this.createTooltip(topic);
            }
        });
    }

    createTooltip(topic) {
        const template = topic.querySelector('[data-dc-news-card-list]');
        tippy(topic, {
            content: template.innerHTML,
            allowHTML: true,
            trigger: 'click',
            theme: 'news',
            placement: 'top',
            interactive: true,
            maxWidth: 275,
            arrow: false,
        });
    }
}
export default CardsLabels;
